import {Modal} from 'react-bootstrap'
import styles from './style.css'

class UploadValidationModal extends React.Component {
  render () {
    let {hideUploadValidationModal, showUploadValidationModal, textModal} = this.props

    return (
      <Modal
        onHide={hideUploadValidationModal}
        show={showUploadValidationModal}
        dialogClassName={`${styles.dialog} modal-dialog margin-top-120`}>
        <Modal.Header>
          <Modal.Title className={styles['title-modal']}>
          Information
        </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            {textModal}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div>
            <button
              type='button'
              className='btn btn-default'
              onClick={hideUploadValidationModal}>
            OK
          </button>
          </div>
        </Modal.Footer>
      </Modal>)
  }
}

UploadValidationModal.propTypes = {
  hideUploadValidationModal: React.PropTypes.func,
  showUploadValidationModal: React.PropTypes.func,
  textModal: React.PropTypes.func
}

export default UploadValidationModal



// WEBPACK FOOTER //
// ./app/components/UploadValidationModal/UploadValidationModal.js